import SectionTitle from "./SectionTitle";
import RegisterLink from "../../../components/RegisterLink";

export default function Conclusion() {
  return (
    <section id="conclusion" className="py-12">
      <SectionTitle>Conclusion</SectionTitle>

      <div
        className="relative rounded-2xl p-8 overflow-hidden"
        style={{
          background: "linear-gradient(135deg, rgba(16,92,232,0.1), rgba(16,92,232,0.06), rgba(201,168,76,0.06))",
          border: "1px solid rgba(16,92,232,0.2)",
          backdropFilter: "blur(16px)",
        }}
      >
        {/* Top shimmer */}
        <div
          className="absolute top-0 left-0 right-0 h-px"
          style={{ background: "linear-gradient(90deg, transparent, rgba(16,92,232,0.4), rgba(224,201,127,0.3), transparent)" }}
        />

        <div className="space-y-4 mb-8">
          {[
            "Ace96au is Asia's Biggest Online Casino, purpose-built for Australian players who want a reliable, exciting, and rewarding gaming experience. Welcome TO Ace96au — Asia's Biggest Online Casino. With a minimum deposit of just AUD 8 and minimum withdrawal of AUD 28, getting started has never been easier.",
            "The platform offers 4000+ games from world-class providers including JILI, VPower, BNG, Spadegaming, Pragmatic Play, Evolution Gaming, CQ9 Gaming, WF Gaming, Live22, Joker, Pegasus, ACE333, 918Kaya, 918Kiss and Mega888. From high RTP pokies (Gates of Olympus 96.5%, Fortune Tiger 96.81%) to live dealer baccarat, fishing games, and card games, there's something for every type of player.",
            "Generous promotions including a FREE 10$ New Register Bonus, 100% Welcome Bonus, 30% Daily First Deposit, 50% Live Welcome Bonus, 50% Sport Welcome Bonus, Weekly Cash Back up to 6%, Special Rebate AUD 50, Free Share Bonus AUD 288, and a Monthly Deposit Ranking competition with prizes up to AUD 1,999 ensure that loyal players are always rewarded.",
            "With 24/7 live chat support, PayID instant deposits, SSL encryption, PAGCOR licensing, RNG certification by iTech Labs and BMM Testlabs, and eCOGRA player protection, Ace96au delivers a safe, fast, and trustworthy experience. Gamble responsibly. 18+ only. Free support: 1800 858 858. It's the top choice for Australian online casino players in 2026.",
          ].map((text, i) => (
            <p key={i} className="text-slate-300 text-sm leading-relaxed">{text}</p>
          ))}
        </div>

        <RegisterLink
          trackLabel="conclusion-signup"
          className="btn-gold px-10 py-4 rounded-xl font-black text-base whitespace-nowrap inline-flex items-center justify-center"
          style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.15em" }}
        >
          SIGN UP NOW
        </RegisterLink>
      </div>
    </section>
  );
}
